import { createStore, Store, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';

import { RootState } from './types';

import rootReducer from './reducer';

const composeEnhancers = (typeof window === 'undefined' ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const loggerMiddleware = createLogger();

const initStore = (): Store<RootState> => {
  const middlewares: any[] = [];

  if (process.env.NODE_ENV === 'development') {
    middlewares.push(loggerMiddleware);
  }

  const store = createStore(rootReducer(), composeEnhancers(applyMiddleware(...middlewares)));

  window.store = store;

  return store;
};

export default initStore;
